<template>
  <div id="fullViewedImage" :tabindex="-1" role="dialog" class="w-full"  @keydown="onKeydown" @click="detectModalClose">
    <!-- modal backdrop -->
    <div class="fixed z-[110] inset-0 h-screen w-full bg-[#2B2B2B]/90" @click.stop="changeModalState(false)"/>
    <!-- close button -->
    <button
        @click.stop="changeModalState(false)"
        type="button"
        class="text-gray-500 bg-gray-700 fixed top-[10px] z-[150] left-[10px] md:left-[4%] md:top-[4%] hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex items-center">
        <img :src="timesIcon" alt width="22" height="22" class="h-[16px] w-[16px] md:h-[18px] md:w-[18px] lg:h-[22px] lg:w-[22px]" />
    </button>
    <!-- modal content -->
    <section class="fixed z-[120] overflow-hidden top-[50%] w-full left-[50%] translate-x-[-50%] translate-y-[-50%] sm:w-[85%] max-h-[100dvh] sm:max-h-[90vh] ">
      <swiper
        @swiper="onSwiper"
        :pagination="{
          type: 'fraction',
        }"
        :initial-slide="initialSlideIndex"
        :dir="isRightToLeft ? 'rtl' : 'ltr'"
        :navigation="true"
        :lazy="true"
        :modules="modules"
        :no-swiping-class="isZooming"
        :no-swiping="isZooming"
        @active-index-change="onItemSelectionChange"
        class="mySwiper"
      >
        <SwiperSlide v-for="(item, index) in this.allItems" :key="item.key" :lazy="true" :class="`m-auto ${isZooming ? 'swiper-no-swiping' : ''}`">
          <div v-if="currentSlideIndex == index">
              <div
              v-if="item"
              :class="`
              ${item.id === 'youtube' ? 'sm:min-w-[520px] bg-transparent w-full xs:w-[85%]' : 'sm:min-w-[480px] bg-transparent w-full xs:w-[90%]'} mx-auto px-0 xs:px-2 md:px-0 flex justify-between items-center gap-2`">
              <div class="w-full">
                <!-- Facebook item -->
                <a
                  v-if="item.id === 'facebook'"
                  aria-label="view product video"
                  :class="`relative block bg-transparent w-[60%] max-h-[75vh] md:max-h-[80vh] h-auto min-w-[150px] lg:max-w-none mx-auto cursor-pointer products-images ${selectedItem.id === item.id ? 'selected-item' : ''}`"
                  :href="item.url"
                  target="_blank"
                  >
                  <img
                    :src="item.image"
                    @error="onImageError"
                    :draggable="false"
                    alt
                    class="w-fit h-auto mx-auto xs:rounded-lg cursor-pointer products-images aspect-square object-fill" />
                  <img
                    class="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[35px] h-[35px] md:w-[40px] md:h-[40px]"
                    :src="playBtnIcon"
                    alt
                    width="40"
                    height="40" />
                </a>
                <!-- Youtube viewer -->
                <LiteYouTubeEmbed v-else-if="item.id === 'youtube' && item.url" :id="getYouTubeId" />

                <!-- images viewer -->
                <div v-else class="single_product_viewer relative">
                  <!-- shows up when loading -->
                  <div v-show="isImageLoading" aria-label="Loading image" class="modal-loader relative h-[400px] min-w-[190px] max-w-[350px]">
                    <img v-if="item && item.image" :src="item.image" class="block w-full h-auto inset-0 absolute opacity-60 lg:max-w-none mx-auto object-contain" alt="loading image" width="250" height="250" />
                    <span class="lds-dual-ring" />
                  </div>
                  <div>
                  <!-- shows up when loaded -->
                  <client-only>
                    <VueImageZoomer
                      :regular="item.original_image || item.image || defaultStoreImage"
                      :zoom="item.original_image || item.image || defaultStoreImage"
                      :img-class="`w-full ${!isImageLoading?'block':'hidden opacity-0'} image_magnifier overflow-hidden xs:rounded-lg object-contain select-none max-h-[100dvh] sm:max-h-[90vh] md:max-h-[80vh] h-auto min-w-[190px] lg:max-w-none mx-auto`"
                      :click-zoom="true"
                      :zoom-amount="3"
                      :click-message="$t('user.click_to_zoom')"
                      @regular-loaded="isImageLoading = false" 
                      @on-zoom="isZooming=true"
                      @off-zoom="isZooming=false"
                      :touch-message="$t('user.click_to_zoom')"/>
                  </client-only>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-lazy-preloader swiper-lazy-preloader-white"/>
          </div>
        </SwiperSlide>
      </swiper>
    </section>

    <!-- xxx -->
    
    
  </div>
</template>

<script>
import defaultStoreImage from "@/assets/images/default-user.svg";
import playBtnIcon from "@/assets/icons/play.svg";
import timesIcon from '@/assets/icons/times.svg';
import LiteYouTubeEmbed from 'vue-lite-youtube-embed';
import 'vue-lite-youtube-embed/style.css';
import 'vue-image-zoomer/dist/style.css';
import { lowerString, onImageError } from "@/helpers";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { ref } from "vue";

  // Import Swiper styles
  import 'swiper/css';

  import 'swiper/css/pagination';
  import 'swiper/css/navigation';

  // import required modules
  import { Pagination, Navigation } from 'swiper/modules';


export default {
  components: {
    LiteYouTubeEmbed,
    Swiper,
    SwiperSlide,
  },
  setup() {
    const usedCookieLanguage = useCookie('localStorageCopy')?.value?.language || 'ar';
    const swiperInstance = ref(null);

    const onSwiper = (swiper) => {
      swiperInstance.value = swiper;
    };
    const changeSliderNavigation = (direction) => {
     const isRightToLeft = lowerString(usedCookieLanguage) == "ar";
      // If rtl, reverse the number to reverse the slide direction
      isRightToLeft && (direction = (+direction * -1));

      if (direction == 1) {
        swiperInstance.value.slideNext();
      } else if(direction == -1){
        swiperInstance.value.slidePrev();
      }
    };
    return {
      modules: [Pagination, Navigation],
      onSwiper,
      changeSliderNavigation,
      usedCookieLanguage
    };
  },
  props: {
    changeModalState: {
      type: Function,
      required: true,
    },
    seletedModalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    selectedItem: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    allItems: {
      type: Array,
      required: true,
      default: () => [],
    },
    setSeletedModalData: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      playBtnIcon,
      timesIcon,
      isImageLoading: true,
      initialSlideIndex: 0,
      currentSlideIndex:0,
      isZooming: false,
      defaultStoreImage
    };
  },
  computed: {
    getYouTubeId() {
      return this.seletedModalData?.url ? this.extractYouTubeId(this.seletedModalData?.url) : '';
    },
    isRightToLeft() {
      return lowerString(this.currentlySelectedLanguage || this.usedCookieLanguage) == "ar";
    },
  },
  methods: {
    onImageError,
    focusOnModalParentElement(){
      const parentEl = document.getElementById("fullViewedImage");
      parentEl?.focus();
    },
    focusOnSelectedImgElement(){
      const selectedImageButton = document.querySelector(".slider-content .selected-item")?.closest('button')
      selectedImageButton?.focus();
    },
    onKeydown(event){
      var keycode;
      if (event.keyCode) {
        keycode = event.keyCode;
      } else if (event.which) {
        keycode = event.which;
      }
      const RIGHT = 39;
      const LEFT = 37;
      const ESC = 27;
      const OK = 13;

      switch (keycode){
        case RIGHT: 
          this.changeSliderNavigation(1);
          break;
        case LEFT:
          this.changeSliderNavigation(-1);
          break;
        case ESC:
        case OK:
          this.changeModalState(false);
          break;
        default: () => {};
      }
    },
    detectModalClose(event){       
      var nonClosableElements = [document.querySelector('picture'), document.querySelector('.swiper-button-next'), document.querySelector('.swiper-button-prev'), document.querySelector('.swiper-pagination'), document.querySelector('.vh--message'), document.querySelector('article')];
      this.$nextTick(() => {
        // trigger clicking ouside these specific elements
        const allowModalClosing = !nonClosableElements.some(element => element?.contains(event.target));
        if (allowModalClosing) {
          // close modal
          this.changeModalState(false);
        }
      })
    },
    onItemSelectionChange(e){
      const { activeIndex } = e || {};
      this.setSeletedModalData(this.allItems[activeIndex], activeIndex);
      this.currentSlideIndex = activeIndex || 0;
    },
    setInitialSlideIndex(){
      const selectedItemIndex = this.allItems?.map(item => item.id).indexOf(this.seletedModalData?.id);
      this.initialSlideIndex = selectedItemIndex >= 0 ? selectedItemIndex : 0;
    },
  },
  watch: {
    seletedModalData: {
      handler(seletedModalData) {
        this.isImageLoading = true;
      },
      deep: true,
      immediate: false,
    },
  },
  mounted(){
    this.focusOnModalParentElement();
  },
  beforeMount(){
    this.setInitialSlideIndex();
  },
  beforeUnmount() {
    this.focusOnSelectedImgElement();
  }
};
</script>

<style lang="scss"  scoped >
#fullViewedImage{
  .swiper-pagination, .vh--message, .vh--outer{
    user-select: none;
  }
  .swiper-button-prev, .swiper-button-next{
    width: 3.8rem;
    height:3.8rem;
    background: rgba(0,0,0,.2);
    border-radius: 50%;
    &::after{
      font-size: 1.6rem;
    }
    @media only screen and (max-width: 670px){
      width: 2.8rem;
      height: 2.8rem;
      &::after{
        font-size: 1.4rem;
      }
    }
  }
  article{
    border-radius: 0.5rem;
    @media only screen and (max-width: 495px){
      border-radius: 0;
    }
  }

  article, video {
    min-height: 190px;
  }
  
  .swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled{
    pointer-events: auto !important;
  }
  .swiper-button-prev, .swiper-button-next{
    color: white;
  }
  .swiper-pagination.swiper-pagination-fraction.swiper-pagination-horizontal{
    bottom: 0% !important;
    color: white;
    text-shadow: 0.5px 0.5px #000000;
    direction: ltr;
  }
}

</style>